/**
    Applies each key/value in an object as a style.
    @param e The d3 selection to apply styles to.
    @param s An object of key/value style pairs.
*/ export default function(e) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    for(var k in s)if (({}).hasOwnProperty.call(s, k)) e.style(k, s[k]);
}

//# sourceMappingURL=stylize.js.map